var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGovernance = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 87 83",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40.878 55.865c-3.362 0-6.724-1.279-9.283-3.839L19.55 39.981l4.242-4.242 12.045 12.045c2.78 2.778 7.302 2.78 10.082 0l36.8-36.8 4.242 4.243-36.8 36.8a13.085 13.085 0 0 1-9.283 3.838ZM82.062 41.97h-6V77H6V16.312c0-5.17 4.205-9.374 9.374-9.374h25.657v-6H15.374C6.897.938 0 7.834 0 16.312V83h82.063V41.97Z",
  fill: "currentColor"
})));
export default SvgGovernance;